import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
const propTypes = {
  skin: PropTypes.oneOf(['standard', 'checkmark', 'minimal']),
  minimal: deprecatedProp(PropTypes.bool, 'Please use skin "minimal" instead')
};
const List = createComponent({
  displayName: 'List',
  root: 'ul',
  propTypes,
  propConfig: {
    classNames(props) {
      const classNameSet = new Set(['swan-list']);
      const {
        skin = 'standard',
        minimal = false
      } = props;
      if (skin != 'standard') classNameSet.add("swan-list-skin-".concat(skin));
      if (minimal && (!skin || skin === 'standard')) classNameSet.add("swan-list-skin-minimal");
      return classNameSet;
    }
  }
});
export { List };